const getDate = function(){ // DESPUÉS MOVER ESTO A UN MIXIN O ÚTILS
    let date = new Date()

    let year = date.getFullYear()

    let month = date.getMonth() + 1
    if(month<10){
        month = `0${month}`
    }else{
        month = `${month}`
    }

    let day = date.getDate()
    if(day<10){
        day = `0${day}`
    }else{
        day = `${day}`
    }

    return `${day}/${month}/${year}`
}

const getTime = function(){ // DESPUÉS MOVER ESTO A UN MIXIN O ÚTILS
    let date = new Date()

    let hours = date.getHours()
    if(hours<10){
        hours = `0${hours}`
    }else{
        hours = `${hours}`
    }

    let minutes = date.getMinutes()
    if(minutes<10){
        minutes = `0${minutes}`
    }else{
        minutes = `${minutes}`
    }

    let seconds = date.getSeconds()
    if(seconds<10){
        seconds = `0${seconds}`
    }else{
        seconds = `${seconds}`
    }
    return `${hours}:${minutes}:${seconds}`
}

export default {
    getDate, getTime
}